/**
 * ISO-3166 Country codes, limited to the Germany and neighbours
 */
export const countryCodes = [
  'AT', // Austria
  'BE', // Belgium
  'CZ', // Czechia
  'DK', // Denmark
  'FR', // France
  'DE', // Germany
  'LU', // Luxembourg
  'NL', // Netherlands
  'PL', // Poland
  'LI', // Lichtenstein
  'CH', // Switzerland
  'IT', // Italy
] as const;
